import { apiClient, apiDelete, apiGet, apiPatch, apiPost, apiPut } from './apiClient.js';

export const financeApi = {
  listAccounts:  (params) => apiGet('/api/finance/accounts', params),
  createAccount: (body)   => apiPost('/api/finance/accounts', body),
  /* Die Systemkonten der Firma: welches Konto welche ROLLE spielt. Das
     Frontend darf Kontonummern nicht kennen - seit dem Kontenrahmen KMU
     heisst der Umsatz 3200 statt 4000, und eine fest verdrahtete 4000 waere
     dort Materialaufwand. */
  systemAccounts: ()      => apiGet('/api/finance/accounts/system'),

  listLedger:    (params) => apiGet('/api/finance/ledger', params),
  postJournal:   (body)   => apiPost('/api/finance/ledger', body),
  /* Das Journal blättert über BELEGE, nicht über Zeilen: sonst zerrisse eine
     Seitengrenze eine Buchung, und die halbe Buchung sähe unausgeglichen aus.
     Gibt {items, meta} zurück - meta.total ist die echte Gesamtzahl. */
  listJournals:  (params) => apiGet('/api/finance/journals', params),
  /* Das Kontoblatt EINES Kontos: Vortrag, Bewegungen, laufender Saldo. */
  accountSheet:  (id, params) => apiGet(`/api/finance/accounts/${id}/sheet`, params),
  reverseJournal: (id, reason) => apiPost(`/api/finance/ledger/${id}/reverse`, { reason }),

  listInvoices:  (params) => apiGet('/api/finance/invoices', params),
  createInvoice: (body)   => apiPost('/api/finance/invoices', body),
  getInvoice:    (id)     => apiGet(`/api/finance/invoices/${id}`),
  postInvoice:   (id)     => apiPatch(`/api/finance/invoices/${id}/post`),
  payInvoice:    (id, b)  => apiPatch(`/api/finance/invoices/${id}/pay`, b),
  invoiceMatch:  (id)     => apiGet(`/api/finance/invoices/${id}/match`).then((r) => r.items),
  refundInvoice:          (id, b) => apiPost(`/api/finance/invoices/${id}/refund`, b),
  listInvoiceCreditNotes: (id)    => apiGet(`/api/finance/invoices/${id}/credit-notes`),
  listCreditNotes:        (params) => apiGet('/api/finance/credit-notes', params),
  getCreditNote:          (id)     => apiGet(`/api/finance/credit-notes/${id}`),
  createCreditNote:       (body)   => apiPost('/api/finance/credit-notes', body),
  postCreditNote:         (id)     => apiPatch(`/api/finance/credit-notes/${id}/post`),
  deleteCreditNote:       (id)     => apiDelete(`/api/finance/credit-notes/${id}`),
  listRecurring:      (params)   => apiGet('/api/finance/recurring-invoices', params),
  getRecurring:       (id)       => apiGet(`/api/finance/recurring-invoices/${id}`),
  createRecurring:    (body)     => apiPost('/api/finance/recurring-invoices', body),
  updateRecurring:    (id, body) => apiPut(`/api/finance/recurring-invoices/${id}`, body),
  setRecurringActive: (id, isActive) => apiPatch(`/api/finance/recurring-invoices/${id}/active`, { isActive }),
  generateRecurring:  (id, force) => apiPost(`/api/finance/recurring-invoices/${id}/generate${force ? '?force=true' : ''}`),
  deleteRecurring:    (id)       => apiDelete(`/api/finance/recurring-invoices/${id}`),
  cancelInvoice: (id)     => apiPatch(`/api/finance/invoices/${id}/cancel`),
  deleteInvoice: (id)     => apiDelete(`/api/finance/invoices/${id}`),
  sendEmail:     (body)   => apiPost('/api/finance/email/send', body),

  listInvoiceAttachments:  (id)       => apiGet(`/api/finance/invoices/${id}/attachments`),
  uploadInvoiceAttachment: (id, body) => apiPost(`/api/finance/invoices/${id}/attachments`, body),
  deleteAttachment:        (id)       => apiDelete(`/api/finance/attachments/${id}`),
  downloadAttachment: async (id, filename) => {
    const res = await apiClient.get(`/api/finance/attachments/${id}/download`, { responseType: 'blob' });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || 'download';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  },

  listBudgets:   (params) => apiGet('/api/finance/budgets', params),
  upsertBudget:  (body)   => apiPost('/api/finance/budgets', body),
  budgetCheck:   (params) => apiGet('/api/finance/budgets/check', params),

  listCashJournals:  (params) => apiGet('/api/finance/cash-journals', params),
  getCashJournal:    (id)     => apiGet(`/api/finance/cash-journals/${id}`),
  createCashJournal: (body)   => apiPost('/api/finance/cash-journals', body),
  postCashEntry:     (body)   => apiPost('/api/finance/cash-journal-entries', body),

  listRecurringJournals: ()     => apiGet('/api/finance/recurring-journals'),
  getRecurringJournal:   (id)   => apiGet(`/api/finance/recurring-journals/${id}`),
  createRecurringJournal:(body) => apiPost('/api/finance/recurring-journals', body),
  runRecurringJournal:   (id)   => apiPost(`/api/finance/recurring-journals/${id}/run`, {}),
  runDueRecurring:       ()     => apiPost('/api/finance/recurring-journals/run-due', {}),
  setRecurringJournalActive: (id, active) => apiPatch(`/api/finance/recurring-journals/${id}/active`, { active }),

  listPaymentTerms:   (params) => apiGet('/api/finance/payment-terms', params),
  createPaymentTerm:  (body)   => apiPost('/api/finance/payment-terms', body),
  computePaymentTerm: (body)   => apiPost('/api/finance/payment-terms/compute', body),

  collectiveInvoiceDue: ()     => apiGet('/api/finance/collective-invoices/due'),
  combineInvoices:      (body) => apiPost('/api/finance/collective-invoices/combine', body),

  trialBalance:  (params) => apiGet('/api/finance/reports/trial-balance', params),
  vatReport:     (params) => apiGet('/api/finance/reports/vat', params).then((r) => r.items),
  income:        (params) => apiGet('/api/finance/reports/income', params),
  balanceSheet:  (params) => apiGet('/api/finance/reports/balance-sheet', params),

  dashboard:     (params) => apiGet('/api/finance/dashboard', params),

  getCompanySettings:  ()     => apiGet('/api/finance/company-settings'),
  saveCompanySettings: (body) => apiPut('/api/finance/company-settings', body),

  dunningOverdue:   (params) => apiGet('/api/finance/dunning/overdue', params),
  listDunning:      (params) => apiGet('/api/finance/dunning', params),
  createDunning:    (body)   => apiPost('/api/finance/dunning', body),
  setDunningStatus: (id, status) => apiPatch(`/api/finance/dunning/${id}/status`, { status }),

  importBankStatement:  (body) => apiPost('/api/finance/bank/import', body),
  listBankTransactions: (status) => apiGet('/api/finance/bank/transactions', status ? { status } : undefined),
  matchBankTransaction: (id, invoiceId) => apiPost(`/api/finance/bank/transactions/${id}/match`, { invoiceId }),
  ignoreBankTransaction: (id) => apiPost(`/api/finance/bank/transactions/${id}/ignore`),

  listCostCenters:  (params) => apiGet('/api/finance/cost-centers', params),
  createCostCenter: (body)   => apiPost('/api/finance/cost-centers', body),
  updateCostCenter: (id, body) => apiPatch(`/api/finance/cost-centers/${id}`, body),
  costCenterReport: ()       => apiGet('/api/finance/reports/cost-centers'),
  setCostCenterPlan: (id, body) => apiPost(`/api/finance/cost-centers/${id}/plan`, body),
  postCost:         (body)   => apiPost('/api/finance/cost-center-postings', body),
  listCostCenterPostings: (params) => apiGet('/api/finance/cost-center-postings', params),
  controllingReport: (fiscalYear) => apiGet('/api/finance/reports/controlling', { fiscalYear }),

  listProfitCenters:   (params) => apiGet('/api/finance/profit-centers', params),
  createProfitCenter:  (body)   => apiPost('/api/finance/profit-centers', body),
  setProfitCenterActive:(id, isActive) => apiPatch(`/api/finance/profit-centers/${id}/active`, { isActive }),
  postProfitCenterEntry:(body)  => apiPost('/api/finance/profit-center-postings', body),
  profitCenterReport:  ()       => apiGet('/api/finance/reports/profit-centers'),

  listDownPayments:    (params) => apiGet('/api/finance/down-payments', params),
  getDownPayment:      (id)     => apiGet(`/api/finance/down-payments/${id}`),
  createDownPayment:   (body)   => apiPost('/api/finance/down-payments', body),
  receiveDownPayment:  (id)     => apiPatch(`/api/finance/down-payments/${id}/receive`),
  applyDownPayment:    (id, body) => apiPost(`/api/finance/down-payments/${id}/apply`, body),

  listCompanyCodes:    (params) => apiGet('/api/finance/company-codes', params),
  createCompanyCode:   (body)   => apiPost('/api/finance/company-codes', body),
  listIntercompanyPostings: (params) => apiGet('/api/finance/intercompany-postings', params),
  createIntercompanyPosting:(body)   => apiPost('/api/finance/intercompany-postings', body),
  intercompanyReconciliation:()     => apiGet('/api/finance/reports/intercompany'),

  reportSources:    ()       => apiGet('/api/finance/report-builder/sources'),
  runReport:        (config) => apiPost('/api/finance/report-builder/run', config),
  listReportDefs:   ()       => apiGet('/api/finance/report-builder/definitions'),
  saveReportDef:    (body)   => apiPost('/api/finance/report-builder/definitions', body),
  deleteReportDef:  (id)     => apiDelete(`/api/finance/report-builder/definitions/${id}`),

  listEquipment:    (params) => apiGet('/api/finance/equipment', params),
  createEquipment:  (body)   => apiPost('/api/finance/equipment', body),
  setEquipmentStatus: (id, status) => apiPatch(`/api/finance/equipment/${id}/status`, { status }),
  listMaintenanceOrders: (params) => apiGet('/api/finance/maintenance-orders', params),
  getMaintenanceOrder: (id) => apiGet(`/api/finance/maintenance-orders/${id}`),
  createMaintenanceOrder: (body) => apiPost('/api/finance/maintenance-orders', body),
  setMaintenanceCosts: (id, body) => apiPatch(`/api/finance/maintenance-orders/${id}/costs`, body),
  startMaintenanceOrder: (id) => apiPatch(`/api/finance/maintenance-orders/${id}/start`),
  completeMaintenanceOrder: (id) => apiPatch(`/api/finance/maintenance-orders/${id}/complete`),
  cancelMaintenanceOrder: (id) => apiPatch(`/api/finance/maintenance-orders/${id}/cancel`),
  listMaintenancePlans: (params) => apiGet('/api/finance/maintenance-plans', params),
  createMaintenancePlan: (body) => apiPost('/api/finance/maintenance-plans', body),
  setMaintenancePlanActive: (id, active) => apiPatch(`/api/finance/maintenance-plans/${id}/active`, { active }),
  generateDuePlans: () => apiPost('/api/finance/maintenance-plans/generate-due', {}),

  listPaymentRuns: () => apiGet('/api/finance/payment-runs'),
  getPaymentRun: (id) => apiGet(`/api/finance/payment-runs/${id}`),
  createPaymentRun: (body) => apiPost('/api/finance/payment-runs', body),
  removePaymentRunItem: (id, itemId) => apiDelete(`/api/finance/payment-runs/${id}/items/${itemId}`),
  executePaymentRun: (id) => apiPatch(`/api/finance/payment-runs/${id}/execute`),
  cancelPaymentRun: (id) => apiPatch(`/api/finance/payment-runs/${id}/cancel`),

  getEbicsStatus:      ()     => apiGet('/api/finance/ebics/status'),
  saveEbicsConfig:     (body) => apiPut('/api/finance/ebics/config', body),
  ebicsInitKeys:       ()     => apiPost('/api/finance/ebics/init-keys'),
  ebicsSendIni:        ()     => apiPost('/api/finance/ebics/ini'),
  ebicsSendHia:        ()     => apiPost('/api/finance/ebics/hia'),
  ebicsFetchBankKeys:  ()     => apiPost('/api/finance/ebics/hpb'),
  ebicsDownload:       (body) => apiPost('/api/finance/ebics/download', body),

  listCurrencies:     (params)      => apiGet('/api/finance/currencies', params),
  createCurrency:     (body)        => apiPost('/api/finance/currencies', body),
  setCurrencyActive:  (code, body)  => apiPatch(`/api/finance/currencies/${code}/active`, body),
  listExchangeRates:  (params)      => apiGet('/api/finance/exchange-rates', params),
  upsertExchangeRate: (body)        => apiPost('/api/finance/exchange-rates', body),
  deleteExchangeRate: (id)          => apiDelete(`/api/finance/exchange-rates/${id}`),
  fetchExchangeRates: ()            => apiPost('/api/finance/exchange-rates/fetch', {}),

  timeseries:       (params) => apiGet('/api/finance/reports/timeseries', params),
  balanceHistory:   (params) => apiGet('/api/finance/reports/balance-history', params),
  aging:            (params) => apiGet('/api/finance/reports/aging', params),
  expenseBreakdown: (params) => apiGet('/api/finance/reports/expense-breakdown', params),
  invoiceStatus:    ()       => apiGet('/api/finance/reports/invoice-status'),

  listFixedAssets:    (params)   => apiGet('/api/finance/fixed-assets', params),
  getFixedAsset:      (id)       => apiGet(`/api/finance/fixed-assets/${id}`),
  createFixedAsset:   (body)     => apiPost('/api/finance/fixed-assets', body),
  updateFixedAsset:   (id, body) => apiPut(`/api/finance/fixed-assets/${id}`, body),
  disposeFixedAsset:  (id, body) => apiPost(`/api/finance/fixed-assets/${id}/dispose`, body),
  runDepreciation:    (period)   => apiPost('/api/finance/fixed-assets/depreciation-run', { period }),
  fixedAssetRegister: ()         => apiGet('/api/finance/fixed-assets/reports/register'),
  fixedAssetInsights: ()         => apiGet('/api/finance/fixed-assets/reports/insights'),

  downloadVatEch0217: async (year, quarter) => {
    const res = await apiClient.get(`/api/finance/reports/vat/ech0217?year=${year}&quarter=${quarter}`, { responseType: 'blob' });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = `mwst-${year}-Q${quarter}.xml`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  },

  listPeriods:   (year)   => apiGet('/api/finance/periods', { year }),
  closePeriod:   (period) => apiPost('/api/finance/periods/close', { period }),
  reopenPeriod:  (period) => apiPost('/api/finance/periods/reopen', { period }),
  yearEndClose:  (year)   => apiPost('/api/finance/periods/year-end-close', { year }),
};
